<template>
  <div>
    <div :class="['report-add-job reports-mul', {isModal: isModal}]">
      <div
        style="width: calc(100% - 30px)"
        :key="index + '_' + (jobs && jobs.id) || 0"
        class="line-data" v-for="(jobs, index) in currentIndex !== null ? [form.jobs[currentIndex]] : form.jobs"
      >
        <div class="pipe-close" style="margin-bottom: 0; margin-top: -10px">
          <i class="el-icon-close" @click="deleteJobs(getIndex(index))" v-if="form.jobs.length > 1 && currentIndex === null"/>
        </div>
        <div class="report-ul mul">
          <AddJobs
            :dirs="dirs"
            :uidData="uidData"
            :type="type"
            :approve="approve"
            :options_works="options_works"
            v-if="_type  === 'MATERIALS' && !form.jobs_internal[getIndex(index)]"
            @add-job="addJobMaterials"
            :report="{...originalForm, ...form}"
            type="JOB"
            :index="index"
            :obj="form.object"
            style="margin-bottom: 20px"
          />
          <div v-if="form.jobs_internal && form.jobs_internal[getIndex(index)]">
            <div class="report-li">
              {{ form.jobs_internal[index] && form.jobs_internal[getIndex(index)].job.name }}
              <div class="report-value">
                <el-input type="number" v-model="form.jobs_internal[getIndex(index)].value"/>
                <strong>
                  {{ form.jobs_internal[index] && form.jobs_internal[getIndex(index)].job.unit && form.jobs_internal[getIndex(index)].job.unit.label || form.jobs_internal[getIndex(index)].job.unit}}
                </strong>
                <i @click="deleteJobInternal(index)" class="el-icon-close"></i>
              </div>
            </div>
          </div>
          <AddJobs
            :dirs="dirs"
            :approve="approve"
            :uidData="uidData"
            :options_works="options_works"
            :report="{...originalForm, ...form}"
            :type="type"
            :unit_prop="form.jobs_internal[getIndex(index)] && form.jobs_internal[getIndex(index)].job && form.jobs_internal[getIndex(index)].job.unit"
            @add-job="addJob" :index="getIndex(index)" :obj="originalForm.object || form.object"/>
          <div
            v-for="(job, i) in jobs" :key="i"
            v-show="job.job.type === type || type !== 'TECH'"
            class="jobs-li"
          >
            <div class="report-li with-check" style="flex-direction: column; align-items: flex-start">
              <div style="display: flex; flex: 1; justify-content: space-between; width: 100%">
                    <span v-if="job.job">{{ job.job && job.job.name }}
                      {{ job.job.unit && `, ${job.job.unit.label || job.job.unit}` }}
                    {{
                        ($store.state.project.plan && $store.state.project.plan.id) || $store.state.project.daily_plan ? '(План|Факт)' : ''
                      }}
                    </span>
                <i @click="deleteJob(i, index, job)" class="el-icon-close"></i>
              </div>
              <div class="report-value">
                <div class="flex">
                  <el-form-item
                    style="width: 50%"
                    v-if="($store.state.project.plan && $store.state.project.plan.id) || $store.state.project.daily_plan">
                    <el-input :value="job.plan"/>
                  </el-form-item>
                  <el-form-item
                    :style="{width: `${($store.state.project.plan && $store.state.project.plan.id) || $store.state.project.daily_plan ? 50 : 100}%`}">
                    <el-input @input="calculateTotal(job)" type="number" v-model="job.value"/>
                  </el-form-item>
                </div>
                <template v-if="job.job.is_unit_value">
                  <el-form-item :label="`Итог`" class="col-vo">
                    <el-input
                      type="number" v-model="job.total"
                    />
                  </el-form-item>
                </template>
                <el-form-item
                  v-if="available_reports && available_reports[`${type || $route.params.type}_TIME`]"
                  label="часы"
                  class="time"
                >
                  <el-input
                    type="number"
                    v-model="job.time"
                  />
                </el-form-item>
              </div>
            </div>
            <el-checkbox
              v-if="_type === 'MATERIALS'"
              v-model="job.is_select"
              label="Добавить в объем"
            ></el-checkbox>
          </div>

          <div
            :style="{marginBottom: `-${$store.state.project.work_dir && !$store.state.project.work_type_ignore ? 20 : 0}px`}">
            <filter-select
              placeholder="Раздел работ"
              v-if="_type !== 'MATERIALS' && $store.state.project.work_dir"
              v-model="form.work_type_dir[currentIndex || index]"
              @input="() => form.work_type[currentIndex || index] = null"
              label="Раздел работ"
              :options="prepareDirs(dirs)"
            />
          </div>
          <filter-select
            v-if="_type !== 'MATERIALS' && !$store.state.project.work_type_ignore"
            v-model="form.work_type[currentIndex || index]"
            :hide-label="$store.state.project.work_dir"
            label="Вид работы"
            @input="selectWorkType(form.work_type[currentIndex || index], index)"
            :options="getWorks(form.work_type_dir && form.work_type_dir[currentIndex || index])"
          />
          <div v-if="_type=== 'MATERIALS'" class="total">
            <span>Итого: <strong>{{ getTotalMaterials(jobs, form.work_type[index]) }}</strong></span>
            <el-button
              size="small"
              @click="form.jobs_internal[index].value = Number(getTotalMaterials(jobs, form.work_type[index]) || 0)"
            >
              + Добавить к факту
            </el-button>
          </div>
          <el-form-item :label="'Место работы'" v-if="form.jobs_internal && form.jobs_internal[index]">
            <el-input v-model="form.jobs_internal[index].place"/>
          </el-form-item>
        </div>
      </div>
      <div
        class="add-block"
        v-if="(_type === 'TECH' || _type === 'PROF' || _type === 'MATERIALS') && !blockAddMore"
      >
        <el-button style="width: 100%" type="primary" size="small" class="add-job" @click="form.jobs.push([])">+ Добавить</el-button>
      </div>
    </div>

    <div v-if="isModal">
      <div style="display: flex; justify-content: flex-end; margin-top: 10px; padding-bottom: 10px">
        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          type="default" @click="$emit('closeWithoutSave')">Отменить</el-button>
        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          type="danger" v-if="currentIndex !== null" @click="deleteJobs(currentIndex)">Удалить</el-button>

        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          type="primary" @click="save">Сохранить</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import {BigNumber} from "bignumber.js";
import AddJobs from './AddJobs';
import FilterSelect from '../../../../components/FilterSelect';
import firebase from "firebase";
import {fetchDirsWithParent, getDirOptions} from "../../../../firestore/dirs";
import {autoComplateChild} from "../mixins/autocomplateChild";
import {v4 as uuidv4} from 'uuid';

export default {
  mixins: [autoComplateChild],
  name: "ListJobs",
  props: {
    available_reports: Object,
    propsForm: Object,
    uidData: Object,
    options_works: Array,
    approve: Boolean,
    type: String,
    blockAddMore: Boolean,
    isModal: Boolean,
    dirs: Array,
    originalForm: {
      type: Object,
      default: () => ({})
    }
  },
  components: {AddJobs, FilterSelect},
  data() {
    return {
      dirs: [],
      currentIndex: null
    }
  },
  computed: {
    form: {
      get() {
        return this.propsForm
      },
      set(s) {
        return this.$emit('update', s)
      }
    },
    _type() {
      return this.type || this.$route.params.type
    }
  },
  mounted() {
    this.fetchTree();
  },
  watch: {
    uidData: {
      deep: true,
      async handler(data) {
        if (data && data.job) {
          let index = 0

          const searchIndex = this.form.jobs.findIndex((jobs) => {
            return jobs[0] && jobs[0].linkedUid === data.uid
          });

          if (this.form.jobs && this.form.jobs[this.form.jobs.length - 1].length && searchIndex === -1) {
            this.form.jobs.push([])
            index = this.form.jobs.length - 1;
          }

          if (searchIndex !== -1) {
            index = searchIndex
            this.currentIndex = index
            return
          }

          this.currentIndex = index

          if(!data.job.work_type) {
            return
          }

          this.form.work_type[index] = this.options_works.find(({id}) => id === data.job.work_type)
          if(this.type !== 'MATERIALS' && this.$store.state.project.work_dir) {

            if(!this.dirs.length) {
              await this.fetchTree()
            }

            this.form.work_type_dir[index] = this.prepareDirs(this.dirs).find(({value, id}) => (value || id) === (this.form.work_type && this.form.work_type[index] && this.form.work_type[index].dir))
          }

          const jobs = await this.fetchJobs();
          const worker = jobs.find((j) => j.name === 'Рабочие')
          const linkedUid = (this.uidData && this.uidData.uid) || null

          if (worker) {
            this.form.jobs[index] = [{
              is_daily: false,
              is_select: null,
              job: worker,
              plan: '',
              time: "",
              linkedUid,
              total: 0,
              uid: uuidv4(),
              value: '',
              work_type: {},
            }]
          }
          this.form.work_type_dir = [...this.form.work_type_dir]

          this.form.jobs = [...this.form.jobs]
          this.index = index
          this.form = {...this.form}
        } else {
          this.currentIndex = null
        }
        },
      immediate: true
    },
  },
  methods: {
    selectWorkType(work_type, index) {
      if(this.$store.state.project.work_dir) {
        this.form.work_type_dir[index] = this.prepareDirs(this.dirs).find(({value}) => work_type.dir === value)
      }
        // this.form.work_type_dir[index]
    },
    prepareDirs(dirs) {
      return dirs.map((r, key) => {
        return {
          ...r,
          label: r.label || r.name,
          value: r.value || r.id,
        }
      })
    },
    save() {
      if(this.$store.state.project.work_type_require) {
        for (let index in this.currentIndex !== null ? [this.form.jobs[this.currentIndex]] : this.form.jobs) {
          const work = this.form.work_type[this.currentIndex || index]
          if(!work || !work.value) {
            this.$notify({
              offset: 60,
              title: 'Заполните поле',
              message: 'Поле "Вид работы" обязательное',
              type: 'error',
            });
            return
          }
        }

      }

      this.$emit('close', this._type)
    },
    getIndex(index) {
      if(this.currentIndex !== null) {
        return this.currentIndex
      }

      return index
    },
    getWorks(id) {
      if (!id || !id.value) {
        return this.options_works
      }

      return this.options_works.filter(({dir}) => dir === id.value);
    },
    fire() {
      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    async fetchTree() {
      this.dirs = await getDirOptions(this.$store.state.project.id);
    },
    addJobMaterials(dd, index) {
      const jobs_internal = this.form.jobs_internal;
      jobs_internal[index] = dd;
      this.form.jobs_internal = [
        ...jobs_internal,
      ];
    },
    deleteJobs(indexInp) {
      let index = indexInp

      if(!indexInp) {
        index = this.currentIndex;
      }

      const jobs = this.form.jobs;
      const work_type = this.form.work_type;

      jobs.splice(index, 1);

      if (work_type.length) {
        work_type.splice(index, 1);
      }

      this.form.jobs = jobs;
      this.form.work_type = work_type;

      if(this.currentIndex !== null) {
        this.$emit('close', this._type)
      }
    },
    getTotalMaterials(_jobs, work_type) {
      const jobs = _jobs.filter((job) => job.is_select);
      const count = jobs.reduce(function (a, b) {
        if (b.job.is_unit_value) {
          return a + Number(String(b['total']).replace(',', '.'));
        } else {
          return a + Number(b['value']);
        }
      }, 0);
      return `${+count.toFixed(4)} ${work_type ? work_type.value : ''}`;

    },
    calculateTotal(input) {
      input.total = new BigNumber(String((input.value || '')).replace(',', '.'))
        .multipliedBy(String(input.job.unit_value || '').replace(',', '.')).toNumber()
    },
    deleteJobInternal(index) {
      const jobs = [...this.form.jobs_internal];
      jobs.splice(index, 1);
      this.form.jobs_internal = [...jobs];
    },
    deleteJob(index, mainIndex = null, job) {
      const jobs = [...this.form.jobs];

      if (mainIndex !== null || this.currentIndex !== null) {
        jobs[this.currentIndex || mainIndex].splice(index, 1);
      } else {
        jobs.splice(index, 1);
      }
      this.form.jobs = [...jobs];
    },
    addJob(dd, index) {
      if (this._type !== 'TECH' && this._type !== 'PROF' && this._type !== 'MATERIALS') {
        const linkedUid = (this.uidData && this.uidData.uid) || null
        this.form.jobs.push({...dd, linkedUid});
      } else {
        const linkedUid = (this.uidData && this.uidData.uid) || ( this.form.jobs[index] &&   this.form.jobs[index][0] && this.form.jobs[index][0].linkedUid) || null
        this.form.jobs[index].push({...dd, linkedUid});
      }

      return this.$emit('update', this.form)
    },
  },
}
</script>

<style lang="scss">
.isModal {

}

.time {
  margin-top: -30px;

  .el-form-item__label {
    height: 30px;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
  }

}

.el-icon-close {
  z-index: 9;
}
</style>
<style scoped>
.add-block {
  width: 100%;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/components/ListJobs.vue